import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["content", "id", "dimmed", "vAlign", "spacingLeft", "spacingRight"];
import React from 'react';
import Icon from 'components/Icon';
import VisuallyHidden from 'components/VisuallyHidden';
import Tooltip from 'components/Tooltip';
function HintTooltip(_ref) {
  var content = _ref.content,
    id = _ref.id,
    _ref$dimmed = _ref.dimmed,
    dimmed = _ref$dimmed === void 0 ? true : _ref$dimmed,
    _ref$vAlign = _ref.vAlign,
    vAlign = _ref$vAlign === void 0 ? true : _ref$vAlign,
    spacingLeft = _ref.spacingLeft,
    spacingRight = _ref.spacingRight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tooltip, _extends({
    content: content
  }, otherProps), function (_ref2) {
    var ref = _ref2.ref,
      open = _ref2.open,
      close = _ref2.close;
    return /*#__PURE__*/React.createElement(Icon, {
      name: "info",
      ref: ref,
      dimmed: dimmed,
      vAlign: vAlign,
      ml: spacingLeft,
      mr: spacingRight,
      onMouseEnter: open,
      onMouseLeave: close,
      onFocus: open,
      onBlur: close,
      tabIndex: 0
    });
  }), content &&
  /*#__PURE__*/
  // The icon triggering the tooltip is invisible
  // to screenreaders, so we add the hint text
  // in a way that makes it discoverable for them
  React.createElement(VisuallyHidden, {
    id: id
  }, content));
}
export default HintTooltip;